var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SubFactorFilter',{attrs:{"action":_vm.filterAction}}),_c('page-title',{staticClass:"mt-2",attrs:{"title_text":"لیست تراکنش های فاکتور"}}),_c('kt-datatable',_vm._b({ref:"datatable"},'kt-datatable',_vm.datatableProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }